import { isAuthenticated } from '@/auth/authGuard'
import { LazyLoadView } from '@/router/utils'

export default [
  {
    name: 'analytics-external',
    path: '/analytics/:id',
    props: route => ({
      id: route.params.id,
      type: route.query.type,
    }),
    component: () => LazyLoadView(import(/* webpackChunkName: "analytics" */ '@/views/Analytics/External.vue')),
    beforeEnter: isAuthenticated,
  },
]
